export default __webpack_public_path__ + "static/media/gift7.ad5a7703.png";